const tr = {
    error1: '伺服器錯誤, 請重試',
    error1_1: '服務器內部錯誤，請稍後再試',
    error1_2: '服務器不支持該請求，請稍後再試',
    error1_3: '服務器不可用，請稍後再試',
    error1_4: '服務器閘道超時，請稍後再試',
    error1_5: '服務器不支持HTTP版本，請稍後再試',
    error2: '需要傳入請求數據',
    error3: '參數錯誤',
    error4: '資料庫未初始化',
    error5: '枚舉類型錯誤',
    error6: '傳參錯誤',
    error7: '缺少token或token已過期',
    error8: 'preUpload.Id不存在',
    error9: 'fileInfo.Id不存在',
    error10: '文件索引已存在',
    error11: '文件缺失part',
    error12: '未找到對應文件',
    error13: 'Admin的權限不允許修改',
    error14: '刷新token不存在',
    error15: '未找到對應數據',
    error16: '未找到手機號',
    error17: '該手機號碼已存在',
    error18: '帳號或密碼錯誤',
    error19: '多個員工不存在',
    error20: '未找到該組織',
    error21: '組織已存在該員工',
    error22: '組織正在盤點',
    error23: '日誌本不存在',
    error24: 'doc不存在',
    error25: '商品種類不存在',
    error26: '商品不存在',
    error27: '掃描不存在',
    error28: '多個掃描不存在',
    error29: '該條碼已存在至該掃描中',
    error30: '沒有找到該出庫單/入庫單數據',
    error31: '庫存不足',
    error32: '沒有找到該盤點單',
    error33: '盤點項不存在',
    error34: '編碼已存在，不得重複添加!',
    error35: '網絡錯誤，請檢查你的網絡連接後重試。',
    error36: '請求超時，請重試。',
    error37: '商品類目編碼重複。',
    error38: '掃描單中無商品數據和條碼數據導致無法出/入庫，即將關閉頁面。',
    error39: '庫存不足',
    error40: '超領申請不存在',
    error41: '申請狀態不允許此操作',
    error42: '需求明細無效或不匹配',
    error43: '超領數量必須大於0',
    error44: '超領明細已生成出庫單',
    error45: '終端客戶編碼已存在',
    error46: '收貨地址不存在',
    error47: '收貨方名稱已存在',
    error48: '設備不存在',
    error49: '目前設備狀態不允許此操作',
    error50: '設備不在庫，無法領用',
    error51: '設備不在用，無法歸還',
    error52: '設備已有未歸還的領用記錄',
    error53: '此記錄類型必須使用專用介面',
    error54: '設備已報廢',
    error55: '設備狀態轉換無效',
    error56: '保養設定無效',
    error57: '資產編號已存在',
    error58: '設備記錄不存在',
    error59: '設備類目編號已存在',
    error60: '設備類目不存在',
    error61: '父類目未啟用，無法啟用子類目',
    error62: '類目下存在子類目，無法刪除',
    error63: '類目已被使用，無法修改編號或名稱',
    error64: '保管部門為必填項',
    error65: '設備只能關聯葉子類目',
    error66: "操作執行排隊中，請稍後再試",
};

export default tr;
